import LegalLayout from "@/components/legal/LegalLayout";
import { Link } from "react-router-dom";

export default function TermsAndConditions() {
    return (
        <LegalLayout
            testId="terms-page"
            eyebrow="Legal · Terms"
            title="Terms &amp; Conditions"
            updated="June 2026"
        >
            <section>
                <p>
                    These Terms &amp; Conditions (&ldquo;Terms&rdquo;) govern your use of
                    the Nicholas Kraus Consulting LLC website
                    (nicholaskrausconsulting.com) and any text messaging or
                    other services we provide. By using our website or opting
                    in to receive text messages, you agree to these Terms.
                </p>
            </section>

            <h2>Organization</h2>
            <p>
                <strong>Nicholas Kraus Consulting LLC</strong>
                <br />
                Ohio-based political consulting firm.
                <br />
                Email:{" "}
                <a
                    href="mailto:nrkraus@nicholaskrausconsulting.com"
                    className="text-gold hover:text-gold-light"
                >
                    nrkraus@nicholaskrausconsulting.com
                </a>
                <br />
                Phone:{" "}
                <a
                    href="tel:+19373213576"
                    className="text-gold hover:text-gold-light"
                >
                    937-321-3576
                </a>
            </p>

            <h2>Text Messaging Program</h2>
            <p>
                By providing your mobile phone number and checking the SMS
                consent box on our contact form (or otherwise opting in), you
                consent to receive text messages from Nicholas Kraus Consulting
                LLC at the number you provided.
            </p>

            <h3>Types of messages you may receive</h3>
            <ul>
                <li>Campaign updates and consulting news from Nicholas Kraus Consulting</li>
                <li>Event announcements, meetings, and volunteer opportunities</li>
                <li>Voter information such as election dates, deadlines, and reminders</li>
                <li>Follow-up messages related to your inquiry or engagement with our services</li>
            </ul>

            <h3>Message Frequency</h3>
            <p>
                Opted-in users may receive approximately{" "}
                <strong>2–5 text messages per month</strong>. Frequency may
                vary during active campaigns or key election periods.
            </p>

            <h3>Message and Data Rates</h3>
            <p className="callout">
                <strong>Message and data rates may apply.</strong> Your mobile
                carrier&apos;s standard messaging and data rates apply to any
                messages you send or receive. Nicholas Kraus Consulting is not
                responsible for these charges. Contact your wireless carrier
                for details about your plan.
            </p>

            <h3>How to Get Help</h3>
            <p>
                To request more information, reply <strong>HELP</strong> to
                any text message from us. You may also email us at{" "}
                <a
                    href="mailto:nrkraus@nicholaskrausconsulting.com"
                    className="text-gold hover:text-gold-light"
                >
                    nrkraus@nicholaskrausconsulting.com
                </a>{" "}
                or call{" "}
                <a
                    href="tel:+19373213576"
                    className="text-gold hover:text-gold-light"
                >
                    937-321-3576
                </a>{" "}
                at any time.
            </p>

            <h3>How to Opt Out</h3>
            <p>
                To stop text messages entirely, reply <strong>STOP</strong> to
                any text message from us. You will receive a single
                confirmation message and will not receive further text
                messages from Nicholas Kraus Consulting unless you opt in
                again.
            </p>

            <h3>Carrier Disclaimer</h3>
            <p>
                Carriers (including but not limited to T-Mobile, AT&amp;T,
                Verizon, Sprint, U.S. Cellular, and others) are not liable for
                delayed or undelivered messages.
            </p>

            <h3>Privacy</h3>
            <p>
                We handle mobile opt-in data in accordance with our{" "}
                <Link
                    to="/privacy"
                    data-testid="terms-privacy-link"
                    className="text-gold hover:text-gold-light underline"
                >
                    Privacy Policy
                </Link>
                . <strong>
                    No mobile opt-in information will be shared with third
                    parties for marketing purposes.
                </strong>
            </p>

            <h2>Use of the Website</h2>
            <p>
                You agree to use nicholaskrausconsulting.com lawfully and only
                for its intended purpose. You may not attempt to gain
                unauthorized access to any portion of the site, interfere with
                its operation, or use it to transmit unlawful, harassing, or
                harmful content.
            </p>

            <h2>Intellectual Property</h2>
            <p>
                All content on this website, including text, graphics, logos,
                and images, is the property of Nicholas Kraus Consulting LLC
                or its licensors and is protected by applicable copyright and
                trademark laws.
            </p>

            <h2>Disclaimer</h2>
            <p>
                Information provided on this site is for general informational
                purposes only and does not constitute legal, financial,
                electoral, or professional advice. Consulting engagements are
                governed by a separate written agreement.
            </p>

            <h2>Limitation of Liability</h2>
            <p>
                To the fullest extent permitted by law, Nicholas Kraus
                Consulting LLC shall not be liable for any indirect,
                incidental, consequential, or punitive damages arising out of
                your use of the website or our text messaging program.
            </p>

            <h2>Changes to These Terms</h2>
            <p>
                We may update these Terms from time to time. Continued use of
                the website or the text messaging program after changes are
                posted constitutes acceptance of the updated Terms.
            </p>

            <h2>Governing Law</h2>
            <p>
                These Terms are governed by the laws of the State of Ohio,
                without regard to its conflict-of-law provisions.
            </p>
        </LegalLayout>
    );
}
